<!--
   Created by qing on 2020/11/10
   Des: 数据视图
-->
<template>
  <div class="space-data-view-container" v-wechat-title="title" v-if="!loading">
    <template v-if="!pageError">
      <FormDataView
        :form-id="formId"
        :app-id="appId"
        :view-id="viewId"
        :view-type="viewType"
        :hasAddForm="false"
        :active-relate-form="{filterInfo}">
      </FormDataView>
      <div
        v-if="allowApply && canApplyForm"
        class="add-button"
        @click="onClickAddForm">
        <i class="el-icon-plus"></i>
      </div>
    </template>

    <div v-else class="error-page">
      <img :src="`${$BASE_PATH}/fetch/image?id=358184796255420417.png`" alt="">
      <p>{{errorInfo}}</p>
      <van-button
        type="primary"
        size="small"
        @click="reloadPage">
        点击重试
      </van-button>
    </div>
  </div>
</template>

<script>
  import {FORM_VIEW_TYPE_DATA_VIEW, FORM_VIEW_TYPE_WRITE_FORM} from "../../../assets/types";
  import FormDataView from "../../component/FormDataView";

  export default {
    inject: ['reload'],
    data() {
      return {
        title: '',
        loading: false,
        FORM_VIEW_TYPE_DATA_VIEW,
        appId: '',
        formId: '',
        viewId: '',
        viewType: '',
        filterInfo: null,
        allowApply: false,
        canApplyForm: false,
        pageError: false,
        errorInfo: '链接错误'
      }
    },
    components: {
      FormDataView
    },
    async created() {
      this.loading = true
      const pageConfig = await this.$store.dispatch('actionSpacePageConfigDetail', {
        spaceId: this.$route.params.spaceId,
        pageConfigId: this.$route.params.pageConfigId
      }).catch(console.error)

      this.title = pageConfig.pageTitle
      this.$store.dispatch('setPageTitle', this.title)
      const pageDetailConfig = pageConfig.pageConfigDetail || {}
      this.appId = pageDetailConfig.appId
      this.formId = pageDetailConfig.formId
      this.viewId = pageDetailConfig.viewId
      this.viewType = pageDetailConfig.viewType || FORM_VIEW_TYPE_DATA_VIEW
      this.filterInfo = pageDetailConfig.filterInfo
      this.allowApply = !!pageDetailConfig.allowApply

      this.$store.commit('UPDATE__FORM_ID', this.formId)
      this.$store.commit('UPDATE__APP_ID', this.appId)

      if (this.appId && this.formId && this.viewId) {
        this.pageError = false
      } else {
        this.pageError = true
      }

      const {
        companyId,
        userId
      } = this.$store.state
      const viewList = await this.$store.dispatch('actionFetchFormViewList', {
        userId,
        companyId,
        appId: this.appId,
        formId: this.formId
      }).catch(console.error)

      if (viewList) {
        const hasViewPer = viewList.some(item => item.viewId === this.viewId)
        if (!hasViewPer) {
          this.pageError = true
          this.errorInfo = '您暂时没有查看该视图权限，请联系管理员'
        }

        this.canApplyForm = viewList.some(item => item.viewType === FORM_VIEW_TYPE_WRITE_FORM)
      }

      this.loading = false

    },
    methods: {

      // 发起表单
      onClickAddForm() {

        const toast = this.$toast.loading({message: '加载中...'})
        this.$store.dispatch('reqNodeSave', {
          appId: this.appId,
          formId: this.formId
        })
          .then(res => {
            this.$router.push({
              name: 'formInput',
              query: {
                key: res.nodeKey
              }
            })
          })
          .catch(err => {
            console.error(err)
          })
          .finally(() => {
            toast.clear()
          })
      },

      reloadPage() {
        this.reload()
      }
    }
  }
</script>

<style lang="less">

  .space-data-view-container {
    height: 100%;
    position: relative;

    .add-button {
      position: absolute;
      bottom: 40px;
      right: 20px;
      border-radius: 50%;
      width: 44px;
      height: 44px;
      padding: 0;
      background-color: #4A66FA;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 3;

      i {
        font-size: 20px;
        color: #ffffff;
      }
    }
  }
</style>